<template >
  <section id="why">
    <!-- <div id="banner" class="animate__animated animate__fadeIn">
        <div class="container-fluid">
            <div class="row">
              <picture>
                <source media="(min-width: 768px)" srcset="../picture/whybuyklm.jpg">
                <source media="(min-width: 1px)" srcset="../picture/whybuyklm.jpg">
                <img src="../picture/whybuyklm.jpg" />
              </picture>
            </div>
        </div>
    </div> -->
    
    <div id="main">
      <div class="container">
          <div class="content-wrapper text1">
            <h2 v-html="$t('whybuyklm.h2')"></h2>
					  <p class="mp-4 bor-b"></p>
            <p class="p mt-4" v-html="$t('whybuyklm.p')"></p>
          </div>
          <div class="blog-wrapper mt-10">
            <div class="row ul">
              <div class="col-my-6 col-xs-6 col-sm-4 col-md-4 li" v-for="(item, index) in colList" :key="index">
                <div class="box" >
                  <img class="animate__animated animate__fadeIn" :src="item.img" />
                  <!-- <div class="icon-tent"></div> -->
                  <div class="tent">
                    <strong v-html="item.title"></strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  metaInfo: {
    title: 'WhyBuyKLM', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'WhyBuyKLM'
    },
    {
      name: 'description',
      content: 'WhyBuyKLM'
    }]
  },
  name: "WhyBuyKLM",
  inject: ['reload'],
  data() {
    return {
      colList: []
    };
  },
  components: {},
  mounted() {
    let that = this
    that.whybuyklm()

    PubSub.subscribe('locale', (msg, data) => {
			if (data.locale != '') {
      	that.reload()
				that.$validator.locale = that.$store.state.locale
			}
		})
  },
  methods: {
		//替换中英文
		whybuyklm() {
			let that = this
			that.colList = that.$t('whybuyklm.col')
		},
    // handleClick(e, val) {
    //   val.off = !val.off
    //   // e.currentTarget.firstElementChild.nextElementSibling.addClass="animated bounceOutLeft"
    //   console.log('target', e.target)
    //   console.log('currentTarget', e.currentTarget.firstElementChild.nextElementSibling)
    //   console.log('currentTarget', e.currentTarget.parentElement)
    // }
  },
};
</script>

<style lang="stylus" scoped>
 /*自己的动画*/
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s
  }

	.p {
    font-size: 16px;	
    line-height: 30px;
    width: 100%;
	}

  /*why*/
  #why .blog-wrapper .row>div {    
    padding-right: 0;
    padding-left: 0;
  }

  #why .blog-wrapper {
    width: 100%;
    .ul {
      margin-right: 0;
      margin-left: 0;
      -webkit-box-align: stretch;
      align-items: stretch;
      display: -webkit-box;
      display: flex;
      flex-wrap: wrap;
      -webkit-box-pack: justify;
      justify-content: space-between;
        
      .li {
        padding: 0 6px;
        margin-bottom: 36px;
        &:nth-of-type(n+3) {
          margin-bottom: 0;
        }
        .box {
          text-align: center;
          .icon-tent {
            display: inline-block;
            width: 100px;
            height: 100px;
            background: red;
          }
          .tent {
            margin-top: 6px;
            p {
              margin-top: 12px;
              margin-bottom: 0;
              font-size: 16px;
              line-height: 24px;
            }
            strong {
              font-size: 21px;
              line-height: 30px;
              // color: #333
            }
          }
          img {
            // width: 100%;
          }
        }
      }
    }
  }
  // #why p {
  //   font-size: 16px;
  //   line-height: 24px;
  //   margin: 35px 0;
  //   i {
  //     font-family: 'AudiTypeExtendedNormal'
  //   }
  // }

  #why .blog {
      position: relative;
      background-color: #e5e5e5;
      padding: 10px;
      margin-bottom: 15px;
  }

  #why .blog-title {
      overflow: hidden;
      margin-bottom: 10px;
  }

  #why .blog-title img {
      float: right;
  }

  #why .show-blog {
      position: relative;
      display: block;
      padding-left: 15px;
      width: 80%;
      color: #000;
      font-size: 12pt;
      text-decoration: initial;
      float: left;
  }

  #why .show-blog:before {
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      background-image: url(../images/plus_btn.png);
      position: absolute;
      left: 0;
      top: 5px;
  }

  #why .active .show-blog:before {
      background-position: 0 -10px;
  }

  #why .blog-content {
      // display: none;
  }

  #why a.more,
  #search a.more {
      color: #000;
      text-decoration: underline;
  }
  
  @media (max-width: 767px) {
    /*why*/
    #why .blog-wrapper .row>div {
        padding-right: 15px;
    }
    #why .blog-wrapper {
      .ul {
        .li {
          padding: 0;
          &:nth-of-type(n+3) {
            margin-bottom: 36px;
          }
          &:nth-of-type(6) {
            margin-bottom: 0 !important;
          }
        }
      }
    }
  }
  
  @media (max-width: 468px) {
    
    #why .blog-wrapper {
      .ul {
        .li {
          padding: 0 10px;
          img {
            width: 70px;
          }
          .tent {
            strong {
              font-size: 18px !important;
              line-height: 21px !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/WhyBuyKLM.vue